module.exports = __webpack_public_path__ + "static/img-girl-assembly-f0a796d5810d36072d228e9c6fc79d8b.jpg";